module.exports = __webpack_public_path__ + "static/img/h3-4.5f72fa2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/h3-4.gif
// module id = 9cQQ
// module chunks = 1